import { render } from "./HostApp.vue?vue&type=template&id=df60831e&lang=pug"
import script from "./HostApp.vue?vue&type=script&lang=js"
export * from "./HostApp.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__